import axios from "axios";

export const approvePickupRequest = (requestNumber: string): Promise<void> =>
  axios.post(`pickupRequests/${requestNumber}/approve`).then(() => undefined);

export default approvePickupRequest;
